export default {
    INVOICE: 'Invoice',
    CUSTOMER_CREDIT_CARD: 'Customer Credit Card',
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment/payment-method-types-enum.js